import { useState, ReactNode, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeContext } from './useTheme';
import secureLocalStorage from '../utils/secureStorage';

interface Props<T> {
  props: T;
  children: ReactNode;
}

function ThemeProvider<T>({ children }: Props<T>) {
  const location = useLocation();
  const initialTheme = () => {
    if (location.pathname === '/login') {
      return false;
    } else {
      if (secureLocalStorage.getItem('swobTheme') != null) {
        return secureLocalStorage.getItem('swobTheme') as boolean;
      } else {
        return true;
      }
    }
  };
  const [theme, setTheme] = useState<boolean>(initialTheme);

  const toggleTheme = () => {
    setTheme((mode) => {
      secureLocalStorage.setItem('swobTheme', !mode);
      return !mode;
    });
  };

  useLayoutEffect(() => {
    // Set theme based on route --> set everything to dark, when login is successful, change to light
    if (location.pathname === '/login') {
      setTheme(false); // Dark theme for login
    } else {
      setTimeout(() => {
        if (secureLocalStorage.getItem('swobTheme') != null) {
          setTheme(secureLocalStorage.getItem('swobTheme') as boolean);
        } else {
          setTheme(true);
        }
      }, 100);
    }
  }, [location.pathname]);

  useLayoutEffect(() => {
    document.body.setAttribute('class', theme ? 'light' : 'dark');
  }, [theme]);

  return <ThemeContext.Provider value={{ toggleTheme, theme }}>{children}</ThemeContext.Provider>;
}
export default ThemeProvider;
